import * as types from './types';
import * as utils from './utils';

const InitialState = {
  filtersSelected: [],
  loading: '',
  filtersTotalState: ''
};

const FilterStatusReducer = (state = InitialState, action) => {
  switch (action.type) {
    case types.ADD_FILTER:
      state.filtersSelected.push(action.payload);
      return { ...state };
    case types.REMOVE_FILTER:
      state.filtersSelected = state.filtersSelected.filter(f => f.value !== action.payload.value);
      return { ...state };
    case types.SET_FILTERS:
      utils.updateSelectedFilter(state.filtersSelected, action.payload);
      return { ...state };
    case types.FETCH_COUNTER_LEAD:
      state.loading = 'loading';
      return { ...state };
    case types.FETCH_COUNTER_LEAD_FAILED:
      state.loading = 'error';
      return { ...state };
    case types.FETCH_COUNTER_LEAD_SUCCEEDED:
      state.loading = 'loaded';
      state.filtersTotalState = action.payload;
      return { ...state };
    default:
      return { ...state };
  }
};

export default FilterStatusReducer;
